<div class="container">

    <div class="row">
        <div class="col-lg-6 col-xl-6 col-md-6 col-12">
            <p>IPv4 address</p>
            <ng-container *ngFor="let p of itemIPAddres">
                <div class="row">
                    <div class="col-8"> <input type="text" class="form-control" [(ngModel)]="p.IP_Number"></div>
                    <div class="col-2">
                        <button class="btn btn-primary w-100" *ngIf="p.IP_Status != 'mock'" (click)="updateIp(p)">
                            บันทึก
                        </button>
                        <button class="btn btn-primary w-100" *ngIf="p.IP_Status == 'mock'" (click)="createIp(p)">
                            บันทึก
                        </button>
                    </div>
                    <div class="col-2">
                        <button class="btn btn-cancel w-100" (click)="deleteIp(p)">
                            ลบ
                        </button>
                    </div>
                </div>
                <br>
            </ng-container>
            <button class="btn btn-primary" (click)="addIP()">
                เพิ่ม IP
            </button>
        </div>
    </div>
</div>